import Timeline from '../general/Timeline'
const LineaMemoriaVerdadJusticia = () => {
    return <Timeline 
        titulo="Hitos. Memoria, verdad y Justicia 1983-2021"
    />
}
export default LineaMemoriaVerdadJusticia